<template>
  <div class="custom-table">
    <el-table
      :data="showList"
      :default-sort="options.defaultSort"
      stripe
      @sort-change="handleSortChange"
    >
      <el-table-column
        v-if="options.showIndex"
        type="index"
        width="100px"
      ></el-table-column>
      <el-table-column
        v-for="bar in options.theader"
        :prop="bar.name"
        :label="bar.label"
        :sortable="bar.sortable"
        :fixed="bar.fixed"
        :width="bar.width"
        :key="bar.name"
      ></el-table-column>
      <!-- 解封 -->
      <el-table-column label="解封" width="180" v-if="options.jiefeng">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >解封</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 对话框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>是否确定解封</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Unseal">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sortDate } from '@/utils/common'

export default {
  name: 'CustomTable1',
  data() {
    return {
      column: '', //排序选项
      dialogVisible: false, // 对话框
      rowrid: '' // 要解封的用户rid
    }
  },
  props: {
    options: {
      type: Object
    },
    tableList: {
      type: Array
    },
    pageSize: {
      type: Number,
      default: 14
    },
    total: {
      type: Number
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  computed: {
    list() {
      if (!this.options.defaultSort) {
        return this.tableList
      }
      let prop = this.column.prop || this.options.defaultSort.prop
      let order = this.column.order || this.options.defaultSort.order
      return this.tableList.concat().sort(function(a, b) {
        if (order === 'descending') {
          if (prop === 'date') {
            return sortDate(b[prop], a[prop])
          } else {
            return b[prop] - a[prop]
          }
        } else {
          if (prop === 'date') {
            return sortDate(a[prop], b[prop])
          } else {
            return a[prop] - b[prop]
          }
        }
      })
    },
    showList() {
      return this.list
    },
    token() {
      return this.$store.getters.token
    }
  },
  methods: {
    // 确定解封
    Unseal() {
      let dateValue = localStorage.getItem('dateValue')
      this.dialogVisible = false
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.un_blocked,
        withCredentials: true,
        params: {
          token: this.token,
          rid: this.rowrid,
          start: dateValue
        }
      }).then(
        res => {
          if (res.status === 200) {
            // localStorage.removeItem('dateValue');
            this.$message({
              showClose: true,
              message: '解封成功',
              type: 'success'
            })
          }
        },
        err => {
          this.$message({
            showClose: true,
            message: '请求错误:' + err,
            type: 'error'
          })
        }
      )
    },
    // 点击解封触发
    handleEdit(index, row) {
      this.dialogVisible = true
      this.rowrid = row.rid
    },
    // 解封二次确认对话框
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    },
    handleSortChange(column) {
      this.column = column
    }
  }
}
</script>

<style lang="stylus" scoped></style>
